export default __webpack_public_path__ + "static/media/Caja_Alta_focus.ad183568.svg";